<template>
  <main>
    <section id="items-list" class="flex flex-col gap-5">
      <div id="actions" class="flex justify-between items-center gap-3">
        <p class="text-xl">{{ "Items*" }}</p>
        <div>
          <Button
            label="Criar Item"
            class="btn-outline"
            @click.prevent="openDialog"
          />
        </div>
      </div>
    </section>
    <section id="items" class="mt-5">
      <div
        id="info-items"
        class="flex justify-between items-center gap-3 bg-h-neutral-200 p-5 shadow rounded font-bold"
      >
        <p>{{ "Items criados" }}</p>
        <p
          :class="[
            { 'text-h-error-600': items.length === 0 },
            { 'text-h-warning-600': items.length >= 1 && items.length < 3 },
            { 'text-h-success-600': items.length >= 3 },
          ]"
        >
          {{ items?.length }} {{ " / 5 itens" }}
        </p>
      </div>

      <EmptyData
        v-if="items?.length === 0"
        :data="items?.length === 0"
        :label="emptyStateItems.description"
        :image="emptyStateItems.image"
        imgSize="h-40 my-10"
        msgSize="lg:w-[350px] -mt-14"
      />

      <div v-else>
        <div v-for="(item, index) in items" :key="index">
          <ItemCard :item="item" :item-index="index" @edit-item="onEditItems" />
        </div>
      </div>
    </section>
    <Dialog
      v-model:visible="open"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '45vw' }"
      :modal="true"
      :draggable="false"
      @hide="closeDialog()"
    >
      <template #header>
        <p class="text-2xl text-center w-full">
          {{ $t("labels.generic", { pt: "Criar Item", en: "Create Item" }) }}
        </p>
      </template>

      <FormItems @on-close="closeDialog" :isEditing="isEditing.items" />
    </Dialog>
  </main>
</template>

<script lang="ts">
import { useQuizQuestionsGapStore } from "@/store/quiz-question-gap";
import { defineComponent, onMounted, ref } from "vue";
import FormItems from "./FormItems.vue";
import ItemCard from "./ItemCard.vue";
import { useRoute } from "vue-router";
import { restoreItems } from "./gap.utils";
import { useEditorStore } from "@/store/editor";

export default defineComponent({
  name: "GapQuestion",
  components: { FormItems, ItemCard },
  data() {
    return {
      emptyStateItems: {
        image: "empty-items.svg",
        description:
          "Você pode cadastrar entre 3 e 5 itens por questão. Clique em “Criar item” para começar.",
      },
    };
  },
  setup() {
    const open = ref(false);
    const route = useRoute();
    const questionStore = useQuizQuestionsGapStore;
    const items = questionStore.items;
    const isEditing = {
      items: { action: false, index: 0 },
    };
    function onEditItems(index: number) {
      open.value = true;

      Object.assign(isEditing.items, { action: true, index: index });
    }
    function openDialog() {
      open.value = true;
      isEditing.items.index = questionStore.items.length;
      isEditing.items.action = false;
    }
    function closeDialog() {
      open.value = false;
      useEditorStore.setEditor(null);
      useEditorStore.setContent(null);
    }
    onMounted(() => {
      if (route.params.id) {
        restoreItems(questionStore);
      }
    });
    return { openDialog, onEditItems, items, open, closeDialog, isEditing };
  },
});
</script>
